import { WorkshiftSchedulingModel, WorkshiftsSchedulingsCopied } from '../../models';

export const WORKSHIFTS_SCHEDULINGS_COPIED_EMPTY: WorkshiftsSchedulingsCopied = {
    toCopy: [],
    workshiftsCopied: {} as WorkshiftSchedulingModel[],
};
